module.exports = __webpack_public_path__ + "static/media/sauna.5afaa8a7.jpg";